export default class MapIconObject {
  static initMapIcon() {
    return {
      IconId: '',
      Name: '',
      GreenIcon: '',
      YellowIcon: '',
      RedIcon: true
    };
  }
}
